module.exports = __webpack_public_path__ + "img/loginimg.0cada474.png";